import {
  TechRadarLoaderResponse,
  TechRadarLoaderResponseParser,
} from '@backstage-community/plugin-tech-radar-common';
import { TechRadarApi } from '@backstage-community/plugin-tech-radar';
import {
  DiscoveryApi,
  FetchApi,
  IdentityApi,
} from '@backstage/core-plugin-api';

type InfraTechRadarClientOptions = {
  discoveryApi: Pick<DiscoveryApi, 'getBaseUrl'>;
  fetchApi: Pick<FetchApi, 'fetch'>;
  identityApi: Pick<IdentityApi, 'getCredentials'>;
};

export class InfraTechRadarClient implements TechRadarApi {
  constructor(private readonly options: InfraTechRadarClientOptions) {}

  async load(): Promise<TechRadarLoaderResponse> {
    const [apiUrl, credentials] = await Promise.all([
      this.options.discoveryApi.getBaseUrl('tech-radar'),
      this.options.identityApi.getCredentials(),
    ]);
    const response = await this.options.fetchApi.fetch(`${apiUrl}/data`, {
      headers: credentials.token
        ? { Authorization: `Bearer ${credentials.token}` }
        : undefined,
    });

    if (!response.ok) {
      throw new Error(
        `Tech Radar backend request failed (${response.status} ${response.statusText})`,
      );
    }

    const result = TechRadarLoaderResponseParser.safeParse(
      await response.json(),
    );
    if (!result.success) {
      throw new Error(
        `Tech Radar backend returned invalid data: ${result.error}`,
      );
    }
    return result.data;
  }
}
